import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GraphqlService } from 'src/app/services/graphql.service';
import { MessageService } from 'primeng';
import { Provider } from '../../../../../generated/graphql';
import { ApproveProvider } from 'src/app/models/provider';
import { ApolloError } from '@apollo/client/errors';

@Component({
  selector: 'app-approve-provider',
  templateUrl: './approve-provider.component.html',
  styleUrls: ['./approve-provider.component.css'],
  providers: [MessageService]
})
export class ApproveProviderComponent implements OnInit {
  readonly displayedColumns = [
    'name',
    'email',
    'Approval',
    'contact',
    'phone number',
    'joined'
  ];
  providers: Provider[] = [];
  posting: boolean;
  loading: boolean;
  approveprovider: ApproveProvider = new ApproveProvider();

  constructor(
    private readonly graphqlService: GraphqlService,
    private readonly messageService: MessageService,
    private readonly changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.fetchProvider();
  }

  fetchProvider() {
    this.graphqlService.findProviders().subscribe((result) => {
      
      this.providers = result.data.findProviders;
      this.providers=[...this.providers]
      this.changeDetector.detectChanges();
    }, console.error);
  }

  async updateProviderStatus(provider_id: string, isVerified: boolean) {
    const providerData = {
      is_verified: isVerified,
      provider_id
    };

    this.graphqlService.updateProvider(providerData).subscribe(
      (result) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Provider is Approved'
        });
        this.fetchProvider();
        this.changeDetector.detectChanges(); // Trigger change detection
      },
      (error: ApolloError) => {
        console.error('There was an error updating the provider status', error);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: `${error.code} : ${error.message}`
        // });
        if (error.graphQLErrors) {
          for (const graphQLError of error.graphQLErrors) {
            // Handle specific GraphQL error codes
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.approveprovider.create_api_result.ServerError.error = messages.join(",")
              this.approveprovider.create_api_result.ServerError.message = messages
              this.approveprovider.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.approveprovider.create_api_result.ServerError.error = messages.join(",")
              this.approveprovider.create_api_result.ServerError.message = messages
              this.approveprovider.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.approveprovider.create_api_result.ServerError.error = null
              this.approveprovider.create_api_result.ServerError.message = messages
              this.approveprovider.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.approveprovider.create_api_result.ServerError.error = messages.join(",")
          this.approveprovider.create_api_result.ServerError.message = messages
          this.approveprovider.create_api_result.ServerError.statusCode = 500
        }

        this.approveprovider.create_api_result.PromiseResult.success = false;
        this.approveprovider.create_api_result.Posting = false;
        this.changeDetector.detectChanges(); 
      }
    );
    
  }
}
